// react
import React, { Component, PropTypes } from "react"
// material-ui
import { Card, CardHeader, CardTitle, CardActions, CardText } from "material-ui/Card"
import FlatButton from "material-ui/FlatButton"
import IconAddress from "material-ui/svg-icons/maps/place"
import IconEmail from "material-ui/svg-icons/communication/email"
import IconPhone from "material-ui/svg-icons/hardware/smartphone"
import IconSkype from "material-ui/FontIcon"
import { ListItem } from "material-ui/List"
// app
import AutoComplete from "containers/AutoComplete"
import Avatar from "components/person/Avatar"
import DatePicker from "components/common/DatePicker"
import SelectField from "containers/SelectField"
import TextField from "components/common/TextField"


const initialState = {
    edit: false,
    firstname_error: false,
    lastname_error: false,
    email_error: false
}

class PersonalDetails extends Component {
    constructor(props) {
        super(props)
        this.state = initialState

        this.setTitle = (title) => this.setState({ title })
        this.setFirstname = (firstname) => this.setState({ firstname })
        this.errorFirstname = (firstname_error) => this.setState({ firstname_error })
        this.setMiddlename = (middlename) => this.setState({ middlename })
        this.setLastname = (lastname) => this.setState({ lastname })
        this.errorLastname = (lastname_error) => this.setState({ lastname_error })
        this.setDob = (dob) => this.setState({ dob })
        this.setMarital = (marital) => this.setState({ marital })
        this.setGender = (gender) => this.setState({ gender })
        this.setCitizenship = (citizenship) => this.setState({ citizenship })
        this.setStreet = (street) => this.setState({ street })
        this.setStateA = (state) => this.setState({ state })
        this.setZip = (zip) => this.setState({ zip })
        this.setCity = (city) => this.setState({ city })
        this.setCountry = (country) => this.setState({ country })
        this.setHomebase = (homebase) => this.setState({ homebase: homebase.toUpperCase() })
        this.setPhone = (phone) => this.setState({ phone })
        this.setSkype = (skype) => this.setState({ skype })
        this.setEmail = (email) => this.setState({ email })
        this.errorEmail = (email_error) => this.setState({ email_error })

        this.edit = () => this.setState({ edit: true })
        this.cancel = () => this.setState(initialState)
        this.save = this.save.bind(this)
    }

    save() {
        const { firstname, middlename, lastname, title, dob, marital, gender, citizenship, street, state, zip, city, country, homebase, email, phone, skype } = this.state

        this.props.onSave({
            id: this.props.person.get("id"),
            firstname, middlename, lastname, title, dob, marital, gender, citizenship, street, state, zip, city, country, homebase, email, phone, skype
        })

        this.setState(initialState)
    }

    renderView() {
        const { person } = this.props
        const zip = person.get("zip", null)
        const city = person.get("city", null)
        const street = person.get("street", null)
        const state = person.get("state", null)
        const country = person.get("country", null)
        const homebase = person.get("homebase", null)
        const gender = person.get("gender", null)
        const marital = person.get("marital", null)
        const displayAge = person.get("displayAge", 0)
        const citizenship = person.get("citizenship", null)
        const email = person.get("email")
        const phone = person.get("phone", null)
        const skype = person.get("skype", null)

        let niceAddress = ""
        if (zip !== null) niceAddress += zip
        if (city !== null) niceAddress += (niceAddress === "") ? ("") : (" ") + city
        if (street !== null) niceAddress += (niceAddress === "") ? ("") : (", ") + street
        if (state !== null) niceAddress += (niceAddress === "") ? ("") : (", ") + state 
        let fullAddress = niceAddress
        if (country !== null) fullAddress = country + (niceAddress === "") ? ("") : (", ") + niceAddress

        let niceName = person.get("displayName")
        if (homebase !== null) niceName += " (" + homebase + ")"
        
        let subtitle = ""
        if (gender !== null) subtitle += gender
        if (marital !== null) subtitle += (subtitle === "") ? ("") : (", ") + marital
        if (displayAge !== 0) subtitle += (subtitle === "") ? ("") : (", ") + displayAge + " years"
        if (citizenship !== null) subtitle += (subtitle === "") ? ("") : (", ") + citizenship

        return (
            <Card className="card">
                <CardTitle
                    title={ niceName }
                    subtitle={ subtitle }
                >
                    <Avatar person={ person } right={ true } />
                </CardTitle>
                <CardText>
                    { niceAddress !== "" ?
                        <a href={ `//maps.google.com/maps?q=${fullAddress}` } target="_blank">
                            <ListItem
                                leftAvatar={ <IconAddress /> }
                                primaryText={ niceAddress }
                                secondaryText={ country }
                            />
                        </a>
                        : null
                    }
                    <a href={ `mailto:${email}` }>
                        <ListItem
                            leftAvatar={ <IconEmail /> }
                            primaryText={ email }
                            secondaryText="Email"
                        />
                    </a>
                    { phone !== null && phone !== "" ?
                        <a href={ `tel:${phone}` }>
                            <ListItem
                                leftAvatar={ <IconPhone /> }
                                primaryText={ phone }
                                secondaryText="Phone"
                            />
                        </a>
                        :
                        null
                    }
                    { skype !== null && skype !== "" ?
                        <a href={ `skype:${skype}` }>
                            <ListItem
                                leftAvatar={ <IconSkype className="fa fa-skype" /> }
                                primaryText={ skype }
                                secondaryText="Skype"
                            />
                        </a>
                        :
                        null
                    }
                </CardText>
                <CardActions>
                    <FlatButton
                        label="Edit"
                        primary={ true }
                        onClick={ this.edit }
                    />
                </CardActions>
            </Card>
        )
    }

    renderEdit() {
        const { person } = this.props

        return (
            <Card className="card">
                <CardHeader title="Personal Details" />
                <CardText>
                    <div className="float-left">
                        <TextField
                            value={ person.get("title", "") }
                            label="Title"
                            onChange={ this.setTitle }
                        />
                        <br />
                        <TextField
                            autoFocus={ true }
                            value={ person.get("firstname") }
                            label="Firstname"
                            mandatory={ true }
                            onChange={ this.setFirstname }
                            onError={ this.errorFirstname }
                        />
                        <br />
                        <TextField
                            value={ person.get("middlename", "") }
                            label="Middlename"
                            onChange={ this.setMiddlename }
                        />
                        <br />
                        <TextField
                            value={ person.get("lastname") }
                            label="Lastname"
                            mandatory={ true }
                            onChange={ this.setLastname }
                            onError={ this.errorLastname }
                        />
                    </div>
                    <div className="float-right">
                        <DatePicker
                            value={ person.get("dob", "") }
                            label="Date of birth"
                            onChange={ this.setDob }
                        />
                        <SelectField
                            table="gender"
                            value={ person.get("gender", "") }
                            label="Gender"
                            onChange={ this.setGender }
                        />
                        <br />
                        <SelectField
                            table="marital"
                            value={ person.get("marital", "") }
                            label="Marital Status"
                            onChange={ this.setMarital }
                        />
                        <br />
                        <AutoComplete
                            table="country"
                            value={ person.get("citizenship", "") }
                            label="Citizenship (Primary)"
                            onChange={ this.setCitizenship }
                        />
                    </div>
                    <div className="clearfix" />
                </CardText>
                <CardHeader title="Address" />
                <CardText>
                    <div className="float-left">
                        <TextField
                            value={ person.get("street", "") }
                            label="Street"
                            onChange={ this.setStreet }
                        />
                        <br />
                        <TextField
                            value={ person.get("zip", "") }
                            label="Postal Code"
                            onChange={ this.setZip }
                        />
                        <br />
                        <AutoComplete
                            table="country"
                            value={ person.get("country", "") }
                            label="Country"
                            onChange={ this.setCountry }
                        />
                        <br />
                        <TextField
                            value={ person.get("email") }
                            label="Email"
                            mandatory={ true }
                            onChange={ this.setEmail }
                            onError={ this.errorEmail }
                        />
                        <br />
                        <TextField
                            label="Phone"
                            value={ person.get("phone") }
                            onChange={ this.setPhone }
                        />
                    </div>
                    <div className="float-right">
                        <TextField
                            value={ person.get("state", "") }
                            label="State"
                            onChange={ this.setStateA }
                        />
                        <br />
                        <TextField
                            value={ person.get("city", "") }
                            label="City"
                            onChange={ this.setCity }
                        />
                        <br />
                        <TextField
                            value={ person.get("homebase", "") }
                            label="Homebase Airport (ICAO Code)"
                            maxLength={ 4 }
                            onChange={ this.setHomebase }
                        />
                        <br />
                        <TextField
                            value={ person.get("skype") }
                            label="Skype"
                            onChange={ this.setSkype }
                        />
                    </div>
                    <div className="clearfix" />
                </CardText>
                <CardActions>
                    <FlatButton
                        label="Save"
                        primary={ true }
                        disabled={ (this.state.firstname_error || this.state.lastname_error || this.state.email_error) }
                        onClick={ this.save }
                    />
                    <FlatButton
                        label="Cancel"
                        secondary={ true }
                        onClick={ this.cancel }
                    />
                </CardActions>
            </Card>
        )
    }

    renderLoading() {
        return (
            <Card className="card">
                <CardHeader title="please wait..." />
            </Card>
        )
    }

    render() {
        // loading
        if (!this.props.person.get("displayName", null)) return this.renderLoading()
        // edit
        if (this.state.edit) return this.renderEdit()
        // view
        return this.renderView()
    }
}

PersonalDetails.propTypes = {
    person: PropTypes.object.isRequired, // immutable.Map()
    onSave: PropTypes.func.isRequired
}

export default PersonalDetails


/** WEBPACK FOOTER **
 ** ./src/components/person/Details/person-details.js
 **/